import { IAttributes, IAugmentedJQuery, IDirective, IScope } from 'angular';
import { noop } from 'lodash-es';

interface IGmcIndeterminateAttrs extends IAttributes {
  gmcIndeterminate: any;
}

export function gmcIndeterminateDirective(): IDirective {
  return {
    compile: ( tElement: IAugmentedJQuery, tArrs: IAttributes ) => {
      if ( !tArrs.type || tArrs.type.toLowerCase() !== 'checkbox' ) {
        return noop;
      }
      return ( $scope: IScope, $element: IAugmentedJQuery, attrs: IGmcIndeterminateAttrs ) => {
        $scope.$watch(attrs.gmcIndeterminate, ( val: any ) => {
          console.log(val);
          $element.prop('indeterminate', !!val);
        });
      };
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-indeterminate/gmc-indeterminate.directive.ts